import { render, staticRenderFns } from "./OfferSalaryAnnexureEditor.vue?vue&type=template&id=57e70c42&scoped=true&"
import script from "./OfferSalaryAnnexureEditor.vue?vue&type=script&lang=js&"
export * from "./OfferSalaryAnnexureEditor.vue?vue&type=script&lang=js&"
import style0 from "./OfferSalaryAnnexureEditor.vue?vue&type=style&index=0&id=57e70c42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e70c42",
  null
  
)

export default component.exports